import React from 'react'

const AddSection = () => {
  return <div></div>
}

export default AddSection
